<template>
  <section>
    <Popup v-model="popupState" popupHeader="Sittercity perks" headerClass="text-h1" popupSize="lg">
      <p class="text-body text-grey-body">Exclusive offers for you from our partners</p>
      <ul class="grid md:grid-cols-2 gap-32 items-stretch md:gap-16 mt-16 mb-48 md:mb-0">
        <li v-for="(perk, i) in perkCards" :key="perk.linkURL || perk.title" :class="i === 2 && 'third-sitter-card'">
          <Card :elevation="1" class="h-full grid">
            <component :is="perk.imageComponent" class="mb-8 h-[24px] w-auto" alt="" />
            <p class="text-strong-body mb-8">{{ perk.title }}</p>
            <p class="text-small mb-8">{{ perk.subheading }}</p>
            <Button
              variant="text"
              :href="perk.linkURL"
              :value="perk.linkText"
              class="pl-0 justify-self-start self-end"
              target="_blank"
              @click="perk.click"
            />
          </Card>
        </li>
      </ul>
    </Popup>
    <p class="text-h4">Quick start</p>
    <ul class="grid grid-cols-2 md:grid-cols-4 md:grid-flow-col gap-32 md:gap-16 mt-16">
      <li v-for="resource in resourceCards" :key="resource.linkURL || resource.title">
        <Card
          :elevation="3"
          :href="resource.linkURL"
          :value="`${resource.title} link`"
          :clickable="true"
          class="w-full flex flex-col items-center justify-center h-144"
          @click="resource.click"
        >
          <component :is="resource.imageComponent" class="mb-16" :width="48" :height="48" />
          <p class="text-strong-body text-center">{{ resource.title }}</p>
        </Card>
      </li>
    </ul>
  </section>
</template>

<script lang="ts">
import JobSearchIllustration from '@/graphics/illustrations/JobSearchIllustration.vue';
import AppliedIllustration from '@/graphics/illustrations/AppliedIllustration.vue';
import CalendarUpToDateIllustration from '@/graphics/illustrations/CalendarUpToDateIllustration.vue';
import PerksIllustration from '@/graphics/illustrations/PerksIllustration.vue';
import Card from '@/components/card/Card.vue';
import Popup from '@/components/popup/Popup.vue';
import Button from '@/components/button/Button.vue';
import ProTrainingsIcon from '@/icons/ProTrainingsIcon.vue';
import GTMPayrollIcon from '@/icons/GTMPayrollIcon.vue';
import { sendSegmentEvent } from '@/lib/segment';

export default {
  name: 'ResourceCards',
  components: {
    JobSearchIllustration,
    AppliedIllustration,
    CalendarUpToDateIllustration,
    PerksIllustration,
    Card,
    Popup,
    ProTrainingsIcon,
    Button,
    GTMPayrollIcon,
  },
  data() {
    return {
      popupState: false,
    };
  },
  computed: {
    perkCards(): any {
      return [
        {
          imageComponent: ProTrainingsIcon,
          linkURL: 'https://www.protrainings.com/sittercity-caregivers',
          linkText: 'View Training',
          title: 'Get free CPR training',
          subheading:
            'Learn how to handle first aid scenarios from experienced paramedics in a free virtual course with the option to purchase certificate.',
          click: () => {
            sendSegmentEvent('Partner Clicked', {
              partnerCardName: 'ProTrainings_Sitters_Perks',
              partnerName: 'ProTrainings',
              ctaUrl: 'https://www.protrainings.com/sittercity-caregivers',
            });
          },
        },
        {
          imageComponent: GTMPayrollIcon,
          linkURL: 'https://gtm.com/household/sittercity-sitters/',
          linkText: 'Refer a family',
          title: 'Get paid on the books',
          subheading:
            'Have a legal employment history, direct deposits, and other work benefits with help from GTM Payroll Services. Refer a family and get a $75 Amazon gift card.',
          click: () => {
            sendSegmentEvent('Partner Clicked', {
              partnerCardName: 'GTM_Payroll_Sitter',
              partnerName: 'GTM Payroll',
              ctaUrl: 'https://gtm.com/household/sittercity-sitters/',
            });
          },
        },
      ];
    },
    resourceCards(): any {
      return [
        {
          imageComponent: JobSearchIllustration,
          title: 'Find Jobs',
          linkURL: '/provider/jobs/search?careType=babysitter',
          click: () => {},
        },
        {
          imageComponent: AppliedIllustration,
          title: 'Applications',
          linkURL: null,
          click: () => {
            window.location.href = '/provider/my-job-applications';
          },
        },
        {
          imageComponent: CalendarUpToDateIllustration,
          title: 'Availability',
          linkURL: '/availability',
          click: () => {},
        },
        {
          imageComponent: PerksIllustration,
          title: 'Perks',
          click: () => {
            this.popupState = true;
            sendSegmentEvent('Partner Impression', {
              partnerCardName: 'ProTrainings_Sitters_Perks',
              partnerName: 'ProTrainings',
              ctaUrl: 'https://www.protrainings.com/sittercity-caregivers',
            });
            sendSegmentEvent('Partner Impression', {
              partnerCardName: 'GTM_Payroll_Sitter',
              partnerName: 'GTM Payroll',
              ctaUrl: 'https://gtm.com/household/sittercity-sitters/',
            });
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.third-sitter-card {
  @media only screen and (min-width: 640px) {
    grid-column: 1 / 3;
  }
}
</style>
